import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { Locale } from 'app/types/app/language'

// eslint-disable-next-line import/no-named-as-default-member
i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: process.env.NODE_ENV === 'development',
        defaultNS: 'translations',
        fallbackLng: Locale.enum['en-GB'],
        keySeparator: false,
        load: 'currentOnly',
        ns: ['translations'],
        nsSeparator: false,
        supportedLngs: Locale.options,

        interpolation: {
            escapeValue: false,
        },

        resources: {
            'en-GB': {
                translations: {
                    actions: 'Actions',
                    activate: 'Activate',
                    activated: 'Activated',
                    active: 'Active',
                    add: 'Add',
                    addProductOrder: 'Add product to order',
                    address: 'Address',
                    admin: 'Admin',
                    ageLimit: 'Under 18s not permitted',
                    alarmLowStock: 'Low stock alarm',
                    all: 'All',
                    allergens: 'Allergens',
                    alreadyLoggedInText:
                        'Ouch! You are already logged in. Close all private browser windows and try again.',
                    alreadyLoggedInTitle: 'Already logged in',
                    amount: 'Amount',
                    amountCart: 'Amount cart',
                    amountCreditCard: 'Amount credit card',
                    amountKonvives: 'Amount Konvives',
                    amountTotal: 'Amount total',
                    amountVat: 'Amount VAT',
                    amountWithoutVat: 'Amount excl. VAT',
                    amountWithVat: 'Amount incl. VAT',
                    anonymous: 'Anonymous',
                    approved: 'Approved',
                    askAgeConfirmation:
                        'Ask for age confirmation (products with an age limit)',
                    atLeastOne: 'Must be at least 1.',
                    author: 'Author',
                    authorisationRequested: 'Autorisation requested',
                    avatar: 'avatar',
                    back: 'Back',
                    banknoteReader: 'Banknote reader',
                    bbd: 'BBD',
                    bbdOutdated: 'BBD outdated',
                    bbdSoonOutdated: 'BBD soon outdated',
                    bbdWithDate: 'BBD : {{date}}',
                    belgium: 'Belgium',
                    block: 'Block',
                    blockCard: 'Block the card',
                    blockedCards: 'Blocked cards',
                    brand: 'Brand',
                    buildingFloor: 'Building / floor',
                    cancelledFeminine: 'Cancelled',
                    cancellingOrder: 'Cancelling order',
                    cancelOrder: 'Cancel order',
                    cancelReason: 'Reason for cancellation',
                    carbs: 'Carbs',
                    card: 'Card',
                    cardAlreadyBlocked: 'The card is already blocked.',
                    cardNumber: 'Card number',
                    cardNumberAlreadyInUse:
                        'The card number is already in use.',
                    cardType: 'Card type',
                    cartDiscount: 'Cart discount',
                    cash: 'Cash',
                    catalogue: 'Catalogue',
                    categories: 'Categories',
                    category: 'Category',
                    channelNotConnected: 'Channel not connected',
                    chooseMachineType: 'Choose the type of machine',
                    chooseManager: 'Choose a manager',
                    chooseSelection: 'Choose a selection',
                    city: 'City',
                    clickOnMicrowave:
                        'Click on a microwave to enable / disable it.',
                    client: 'Client',
                    clientCreation: 'Client creation',
                    clientFilter: 'Client filter',
                    clients: 'Clients',
                    closedLocker: 'Locker closed',
                    closingTime: 'Closing time',
                    codes: 'Codes',
                    column: 'Column ',
                    commercialInformation: 'Commercial information',
                    communicationLost: 'Communication lost',
                    confirm: 'Confirm',
                    confirmDeletionText:
                        'Are you sure you want to delete it permanently?',
                    confirmDeletionTitle: 'Confirmation of deletion',
                    connectionToTerminal: 'Connection to terminal',
                    contact: 'Contact',
                    contacted: 'Contacted',
                    contactNumber: 'Contact number',
                    containsIcoupon: 'Contains iCoupon',
                    contract: 'Contract',
                    contractDuration: 'Contract duration (months)',
                    contractNumber: 'Contract number',
                    cookingRequirements: 'Cooking requirements',
                    cookingTemperature: 'Cooking temperature',
                    cookingTime: 'Cooking time',
                    copied: 'Copied to the clipboard.',
                    correct: 'Correct',
                    country: 'Country',
                    created: 'Successfully created!',
                    creation: 'Creation',
                    creationDate: 'Creation date',
                    creditCard: 'Credit card',
                    customerService: 'Customer service',
                    customerServiceMessage:
                        'Do you have a problem? Create a ticket on <link />. You’ll be able to follow its progress.',
                    customisedFeminine: 'Customised',
                    date: 'Date',
                    dateEnd: 'End date',
                    datePassage: 'Passage date',
                    datePassageInfo: 'Passage date : {{date}}',
                    dates: 'Dates',
                    dateSignature: 'Date of signature',
                    dateStart: 'Start date',
                    dayEnd: 'End day',
                    dayEndError: 'The end date is earlier than start date.',
                    dayStart: 'Start day',
                    dayStartError: 'The start date exceeds end date.',
                    deactivate: 'Deactivate',
                    deactivated: 'Deactivated',
                    defaultLanguageCustomer: 'Default customer language',
                    defaultLanguageIntervenor: 'Default intervenor language',
                    delete: 'Delete',
                    deleted: 'Successfully deleted!',
                    deliveries: 'Deliveries',
                    deliveryMan: 'Delivery man',
                    deliveryManCreation: 'Delivery man creation',
                    deliveryMen: 'Delivery men',
                    description: 'Description',
                    desired: 'Desired',
                    destocking: 'Destocking',
                    diagnostic: 'Diagnostic',
                    discount: 'Discount',
                    discounts: 'Discounts',
                    discountsPriorities: 'Discounts priorities',
                    dispensingCancelled: 'Dispensing cancelled',
                    dispute: 'Dispute',
                    disputedFeminine: 'Disputed',
                    disputeState: 'Dispute state',
                    distributionSpeed: 'Distribution speed',
                    distributor: 'Distributor',
                    divider: 'Divider',
                    domainName: 'Domain name',
                    doorOpen: 'Door open',
                    download: 'Download',
                    dropFileHere: 'Drop file here.',
                    duplicate: 'Duplicate',
                    elevatorFault: 'Elevator fault',
                    eligibleFridgeWeight: 'Eligible weight fridge',
                    eligibleLuncheonVouchers: 'Eligible luncheon vouchers',
                    email: 'Email',
                    emailAlreadyInUse: 'This email is already in use.',
                    emailError: 'A valid email is required.',
                    emailResetPassword: 'Email sent to reset your password!',
                    emailSignatory: 'Email signatory',
                    employerContribution: 'Employer contribution',
                    empty: 'Empty',
                    encodedProducts: 'Encoded products',
                    endTime: 'End time',
                    energy: 'Energy',
                    english: 'English',
                    errorAlarmRedLed:
                        'The red timer should be higher than the set yellow LED timer.',
                    errorAlarmYellowLedOne:
                        'The yellow alarm timer must be set to at least 5 seconds after the door has been opened.',
                    errorAlarmYellowLedTwo:
                        'The yellow alarm timer must be set at least 5 seconds before the red LED timer.',
                    errorDiffTempTooHighOne:
                        'The differential must be less than the high temperature threshold minus the set temperature.',
                    errorDiffTempTooHighTwo:
                        'The differential must be less than the set temperature subtracted by the low temperature threshold.',
                    errorFieldRequired: 'This field is required.',
                    errorHighTempThresh:
                        'The high temperature threshold must be higher than the low temperature threshold and must not exceed 25 °C.',
                    errorImportNumeric: 'This field must be a number.',
                    errorImportString: 'This field cannot be a number.',
                    errorInUse: 'This item is currently in use.',
                    errorLowTempThreshTooHigh:
                        'The low temperature threshold must be lower than the high temperature threshold.',
                    errorLowTempThreshTooLow:
                        'The low temperature threshold must be lower than the setpoint temperature added by the differential one.',
                    errorOpenDoorTimer:
                        'The door unlock timer must be set to a minimum of 5 seconds and must be at least 5 seconds shorter than the yellow alarm timer.',
                    errorPhoto: 'A photo is required.',
                    errorSetpointTempTooHigh:
                        'The temperature must be below the high temperature threshold subtracted from the differential.',
                    errorSetpointTempTooLow:
                        'The temperature must be higher than the low temperature threshold plus the differential.',
                    errorTempNotBetweenSetLimits:
                        'The temperature should be set between -30 and 23 °C included',
                    errorTryLater:
                        'An error has occurred, please try again later.',
                    errorUserCreation:
                        'An error has occured while creating the Konsole user.',
                    excelPercentage: '#,#0.0"%"',
                    excelPrice: '"€"#,##0.00',
                    excelPriceWeight: '"€ / Kg"#,##0.00',
                    expiredFeminine: 'Expired',
                    export: 'Export',
                    exportInPreparation: 'The export is in preparation…',
                    fats: 'Fats',
                    fibres: 'Fibres',
                    fieldRequiredFill: 'Fill in all the required fields.',
                    fileSizeError: 'File size is too big.',
                    fill: 'Fill',
                    filters: 'Filters',
                    final: 'Final',
                    firstName: 'First name',
                    firstNameSignatory: 'First name signatory',
                    forgottenPassword: 'Password forgotten?',
                    france: 'France',
                    french: 'French',
                    friday: 'Friday',
                    fridgeRfid: 'e-Fridge',
                    fridgeWeight: 'Weight fridge',
                    from: 'From',
                    furtherInformation: 'Additional information',
                    general: 'General',
                    generalInformation: 'General information',
                    generate: 'Generate',
                    germany: 'Germany',
                    globalInformation: 'Global information',
                    groupBy: 'Group by',
                    grouped: 'Grouped',
                    history: 'History',
                    idCardReader: 'ID card reader',
                    identifier: 'Identifier',
                    impersonate: 'Impersonate',
                    impersonateInstructions:
                        'Right-click on <link /> and open it in a new private browser window. That’s it, you’ve impersonated the identity!',
                    import: 'Import',
                    imported: 'Successfully imported!',
                    importModificationText:
                        'Are you sure you want to change the import type? Any changes will be lost.',
                    importModificationTitle: 'Import modification',
                    importProducts: 'Import products',
                    importProductsLimited:
                        'Import products limited to {{number}}',
                    importVerb: 'Import',
                    inactive: 'Inactive',
                    incidents: 'Incidents',
                    incidentsRabbitmq: 'Incidents RabbitMQ',
                    inFitsAndStarts: 'In fits and starts',
                    infoOutdated:
                        'Bdd outdated are not considered on passage date selected.',
                    informative: 'Informative',
                    inPreparation: 'In preparation',
                    inProgress: 'In progress…',
                    instructions: 'Instructions',
                    internet: 'Internet',
                    interventions: 'Interventions',
                    ipAddress: 'IP address',
                    italy: 'Italy',
                    konvivesLink: 'Konvives link',
                    lastActivityDate: 'Last activity date',
                    lastLoss: 'Last lost :',
                    lastName: 'Last name',
                    lastNameSignatory: 'Last name signatory',
                    lastSign: 'Last sign :',
                    lifespan: 'Lifespan (days)',
                    line: 'Line',
                    loading: 'Loading in progress…',
                    locationErrorDuplicate: 'A selection number is duplicated.',
                    locationErrorEmpty: 'A selection is empty.',
                    locationErrorMotor: 'Two engines have the same positions.',
                    locationErrorPlanogramName: 'Missing planogram name.',
                    locationErrorPlanogramOrder: 'Missing planogram order.',
                    lockerCold: 'Cold locker',
                    lockerDry: 'Dry locker',
                    logIn: 'Log in',
                    login: 'Login',
                    logistics: 'Logistics',
                    logOut: 'Log out',
                    luxembourg: 'Luxembourg',
                    machine: 'Machine',
                    machineChoice: 'Choice of machine',
                    machineChoiceDetails:
                        'Choose the machine on which to create the planogram.',
                    machineOptionsAndTechnicalData:
                        'Technical data / machine options',
                    machines: 'Machines',
                    machineType: 'Machine type',
                    managementSelection: 'Selection management',
                    managementTray: 'Tray management',
                    manager: 'Manager',
                    managerCreation: 'Manager creation',
                    managerEditionText:
                        'Are you sure you want to change manager? Any changes will be lost.',
                    managerEditionTitle: 'Manager edition',
                    managerItemCode: 'Manager item code',
                    managers: 'Managers',
                    manual: 'Manual',
                    marketingImagesAndVideos: 'Marketing images / videos',
                    maximum: 'Maximum',
                    mealVoucher: 'Meal voucher',
                    menuNotTaken: 'Menu not taken into account',
                    menus: 'Menus',
                    microwave: 'Microwave',
                    microwaveCreation: 'Microwave creation',
                    microwaves: 'Microwaves',
                    mifareCode: 'MIFARE code',
                    mifareCodeAlreadyInUse:
                        'The MIFARE code is already in use.',
                    model: 'Model',
                    modification: 'Modification',
                    modificationDate: 'Modification date',
                    modifyProductInfo: 'Modify product information',
                    modifyTechnicalData: 'Modify the technical data',
                    monday: 'Monday',
                    month: 'Month',
                    motor: 'Motor',
                    motorActivation: 'Motor activation after distribution',
                    motorFailure: 'Motor failure',
                    name: 'Name',
                    navigationBar: 'Navigation bar',
                    netherlands: 'Netherlands',
                    newClient: 'New client',
                    newDeliveryMan: 'New delivery man',
                    newManager: 'New manager',
                    newMicrowave: 'New microwave',
                    newNamePriceTable: 'New name of the price table',
                    newOrder: 'New order',
                    newProduct: 'New product',
                    newProfile: 'New profile',
                    newReport: 'New report',
                    newService: 'New service',
                    newSite: 'New site',
                    newSupplier: 'New supplier',
                    newTable: 'New table',
                    newTechnician: 'New technician',
                    next: 'Next',
                    no: 'No',
                    noAdmin: 'No admin',
                    noBlockedCardAvailable: 'No blocked card available.',
                    noChange: 'No change.',
                    noClientAvailable: 'No client available.',
                    noDeliveryManAvailable: 'No delivery man available.',
                    noDiagnosticAvailable: 'No diagnostic available.',
                    noEmployerContributionAvailable:
                        'No employer contribution available.',
                    noManagerAvailable: 'No manager available.',
                    noMicrowaveAvailable: 'No microwave available.',
                    none: 'None',
                    noOrderAvailable: 'No order available.',
                    noPlanogramAvailable: 'No planogram available.',
                    noProductAvailable: 'No product available.',
                    noProductSelected: 'No product selected.',
                    noProfileAvailable: 'No profile available.',
                    noRefillAvailable: 'No refill available.',
                    noReportAvailable: 'No report available.',
                    noResultAvailable: 'No result available.',
                    noSaleAvailable: 'No sale available.',
                    noServiceAvailable: 'No service available.',
                    noSiteAvailable: 'No site available.',
                    noSupplierAvailable: 'No supplier available.',
                    noTechnicianAvailable: 'No technician available',
                    noUserAvailable: 'No user available.',
                    numberProducts: 'Number of products incorrect',
                    nutritionalValues: 'Nutritional values',
                    onDelivery: 'On delivery',
                    onlyShortBbd: 'Only short BBD',
                    openingTime: 'Opening time',
                    openingTimes: 'Opening times',
                    openLocker: 'Open the locker',
                    openLockerConfirmation:
                        'Are you sure you want to open locker {{mapping}}?',
                    operations: 'Operations',
                    order: 'Order',
                    orderCreation: 'Order creation',
                    orderNotFound: 'Order not found',
                    orderNumber: 'Order n°{{number}}',
                    orders: 'Orders',
                    other: 'Other',
                    park: 'Park',
                    password: 'Password',
                    passwordConfirm: 'Confirm your new Password',
                    passwordNew: 'New password',
                    passwordResetAction: 'Reset password',
                    passwordResetTitle: 'Reset your password',
                    passwordRuleCommon:
                        'Too common/obvious passwords are also blocked.',
                    passwordRuleIntro: 'Your password must contain at least:',
                    passwordRuleLength: '12 characters minimum',
                    passwordRuleLowercase: '2 lowercase letters',
                    passwordRuleNumber: '2 numbers',
                    passwordRuleSpecial: '2 special characters',
                    passwordRuleUppercase: '2 uppercase letters',
                    passwordsDoNotMatch: 'Passwords do not match.',
                    passwordsMustBeStronger: 'The password must be stronger.',
                    paymentMethod: 'Payment method',
                    pending: 'Pending',
                    phone: 'Phone',
                    phoneSignatory: 'Phone signatory',
                    photo: 'Photo',
                    planogramCreate: 'Create a planogram',
                    planogramDeleteAsk:
                        'Are you sure you want to delete this planogram?',
                    planogramOrder: 'Order',
                    planograms: 'Planograms',
                    port: 'Port',
                    portugal: 'Portugal',
                    position: 'Position',
                    postalCode: 'Postal code',
                    power: 'Power',
                    preferLibreOffice: 'For optimal use, prefer LibreOffice.',
                    price: 'Price',
                    priceKonvives: 'Konvives price',
                    pricePrivateCard: 'Private card price',
                    priceStandard: 'Standard price',
                    priceTableCreation: 'Price table creation',
                    priceTables: 'Price tables',
                    priceUnit: 'Unit price',
                    priceWeight: 'Price by weight',
                    printer: 'Printer',
                    privateCard: 'Private card',
                    problem: 'Problem',
                    product: 'Product',
                    productChange: 'Product change',
                    productCreation: 'Product creation',
                    productExpired: 'Product expired',
                    productListErrors: 'Products list errors',
                    products: 'Products',
                    productsDistributed: 'Products distributed',
                    productsExcluded: 'Products to exclude',
                    productsNotDistributed: 'Products not distributed',
                    productSoldOut: 'Product sold out',
                    profile: 'Profile',
                    profileCreation: 'Profile creation',
                    profiles: 'Profiles',
                    pspReference: 'PSP reference',
                    purchaseInvoice: 'Purchase invoice',
                    purchasePrice: 'Purchase price',
                    purchasePriceAsc: 'Purchase price (ascending)',
                    purchasePriceDesc: 'Purchase price (descending)',
                    quantity: 'Quantity',
                    quantityAsc: 'Quantity (ascending)',
                    quantityDesc: 'Quantity (descending)',
                    queueFull: 'Queue full',
                    reading: 'Reading',
                    readyFeminine: 'Ready',
                    reason: 'Reason',
                    rebootApt: 'Reboot the APT',
                    rebootAptConfirmation:
                        'Are you sure you want to reboot the APT?',
                    receipt: 'Receipt',
                    recommended: 'Recommended',
                    recommendedDeliveryTime: 'Recommended delivery time',
                    recreditation: 'Recreditation',
                    refill: 'Refill',
                    refills: 'Refills',
                    refund: 'Refund',
                    refundedFeminine: 'Refunded',
                    refunds: 'Refunds',
                    refundVerb: 'Refund',
                    refuse: 'Refuse',
                    refused: 'Refused',
                    refusedFeminine: 'Refused',
                    removedFeminine: 'Removed',
                    rename: 'Rename',
                    reportQueue: 'Report in the queue!',
                    reports: 'Reports',
                    reportsGeneratedKept:
                        'The reports generated are kept for 30 days before being deleted.',
                    resetPassword: 'Reset password',
                    resetPasswordInstruction:
                        'Enter your email address. You will receive a link to reset your password.',
                    resetSelectionPriceWeight: 'Product selection reset',
                    resetSelectionPriceWeightTextPlural:
                        'The selections of products switched to weight-based pricing present in the machines will be cleared.',
                    resetSelectionPriceWeightTextSingular:
                        'The selections for the product present in the machines will be cleared.',
                    restartComputer: 'Restart the computer',
                    restartComputerConfirmation:
                        'Are you sure you want to restart the computer?',
                    retrievedBySomeoneElse: 'Retrieved (other)',
                    retrievedFeminine: 'Retrieved',
                    sale: 'Sale',
                    saleReport: 'Sale report',
                    saleReportCreation: 'Sale report creation',
                    saleReports: 'Sale reports',
                    sales: 'Sales',
                    salesLog: 'Sales log',
                    salesLogCreation: 'Sales log creation',
                    saleStatus: 'Sale status',
                    saturatedFat: 'Saturated fat',
                    saturday: 'Saturday',
                    screen: 'Screen',
                    searchAddress: 'Search address',
                    sector: 'Sector',
                    selectCancelOrderReason:
                        'Please select a reason for cancelling the order.',
                    selectClientSiteOrTerminal:
                        'Select a client, a site or a terminal.',
                    selection: 'Selection',
                    selectionNotConfigured: 'Selection not configured',
                    selectionNumber: 'Selection number',
                    selectKonviveOrPhone: 'Select Konvive or add phone number',
                    selectLockerToOpen: 'Select the locker to open',
                    selectSiteDelivery: 'Select a site for delivery',
                    selectSiteOrTerminal: 'Select a site or a terminal.',
                    selfService: 'Self-service',
                    sent: 'Successfully sent!',
                    serialNumber: 'Serial number',
                    service: 'Service',
                    serviceCreation: 'Service creation',
                    serviceFilter: 'Service filter',
                    serviceReport: 'Service report',
                    serviceReportCreation: 'Service report creation',
                    serviceReports: 'Service reports',
                    services: 'Services',
                    settings: 'Settings',
                    signatory: 'Signatory',
                    signature: 'Signature',
                    site: 'Site',
                    siteCreation: 'Site creation',
                    siteFilter: 'Site filter',
                    sites: 'Sites',
                    size: 'Size',
                    sizeInform: 'Resize the selections.',
                    sortBy: 'Sort by',
                    spain: 'Spain',
                    spanish: 'Spanish',
                    split: 'Split',
                    standard: 'Standard',
                    startTime: 'Start time',
                    status: 'Status',
                    steps: 'Steps',
                    stock: 'Stock',
                    stockMachines: 'Machine stock',
                    stockMaximum: 'Maximum stock',
                    stockRecommended: 'Recommended stock',
                    stockReport: 'Stock report',
                    subcategory: 'Subcategory',
                    sunday: 'Sunday',
                    supervisor: 'Supervisor',
                    supplier: 'Supplier',
                    supplierCreation: 'Supplier creation',
                    supplierFilter: 'Supplier filter',
                    suppliers: 'Suppliers',
                    supply: 'Supply',
                    supplyDays: 'Supply days',
                    supplyReport: 'Supply report',
                    support: 'Support',
                    supportEmail: 'Support email',
                    supportPhone: 'Support phone',
                    switchInactive: 'Switch to inactive',
                    switchPending: 'Switch to pending',
                    switzerland: 'Switzerland',
                    table: 'Table',
                    technician: 'Technician',
                    technicianCreation: 'Technician creation',
                    technicians: 'Technicians',
                    terminal: 'Terminal',
                    terminalFilter: 'Terminal filter',
                    terminals: 'Terminals',
                    text: 'Text',
                    theme: 'Theme',
                    thisLink: 'this link',
                    thursday: 'Thursday',
                    ticket: 'Ticket',
                    timeEndError: 'End time is earlier than the start time.',
                    timeSlotNumber: 'Slot {{number}}',
                    timeSlotOverlap:
                        'The time slot must not overlap with another slot.',
                    timeSlots: 'Time slots',
                    timeStartError: 'Start time exceeds end time.',
                    to: 'to',
                    toRefill: 'To refill',
                    total: 'Total',
                    totalRefund: 'Total refund :',
                    transactions: 'Transactions',
                    tuesday: 'Tuesday',
                    turnoverWithoutVat: 'Turnover (without VAT)',
                    turnoverWithoutVatAsc: 'Turnover (without VAT) (ascending)',
                    turnoverWithoutVatDesc:
                        'Turnover (without VAT) (descending)',
                    turnoverWithVat: 'Turnover (with VAT)',
                    type: 'Type',
                    unblockCard: 'Unblock the card',
                    unitedKingdom: 'United-Kingdom',
                    unitedStateOfAmerica: 'United States of America',
                    units: 'Units',
                    unknownError: 'Unknown error',
                    unlockHatch: 'Unlock the hatch',
                    unlockHatchConfirmation:
                        'Are you sure you want to unlock the hatch?',
                    update: 'Update',
                    updated: 'Successfully updated!',
                    updatedLightningSchedules: 'Updated lighting schedules.',
                    ups: 'UPS',
                    userInformation: 'User information',
                    userKonsole: 'Konsole user',
                    username: 'Username',
                    usernameAlreadyInUse: 'This username is already in use.',
                    usernameOrPasswordIncorrect:
                        'Username or password incorrect.',
                    users: 'Users',
                    usersKonsole: 'Konsole users',
                    usersKonsoleCreation: 'Konsole user creation',
                    usersNew: 'New user',
                    vat: 'VAT',
                    volume: 'Volume',
                    wednesday: 'Wednesday',
                    weight: 'Weight',
                    wrongPrice: 'Wrong price',
                    wrongProduct: 'Wrong product',
                    yes: 'Yes',
                    zone: 'Area',
                },
            },

            'fr-FR': {
                translations: {
                    actions: 'Actions',
                    activate: 'Activer',
                    activated: 'Activé',
                    active: 'Actif',
                    add: 'Ajouter',
                    addProductOrder: 'Ajouter des produits à la commande',
                    address: 'Adresse',
                    admin: 'Admin',
                    ageLimit: 'Interdit aux moins de 18 ans',
                    alarmLowStock: 'Alarme stock bas',
                    all: 'Tous',
                    allergens: 'Allergènes',
                    alreadyLoggedInText:
                        'Aïe ! Vous êtes déjà connecté. Veuillez fermer toutes les fenêtres de navigation privée et veuillez réessayer.',
                    alreadyLoggedInTitle: 'Déjà connecté',
                    amount: 'Montant',
                    amountCart: 'Montant panier',
                    amountCreditCard: 'Montant carte de crédit',
                    amountKonvives: 'Montant Konvives',
                    amountTotal: 'Montant total',
                    amountVat: 'Montant TVA',
                    amountWithoutVat: 'Montant HT',
                    amountWithVat: 'Montant TTC',
                    anonymous: 'Anonyme',
                    approved: 'Approuvé',
                    askAgeConfirmation:
                        'Demander la confirmation de l’âge (produits avec une limite d’âge)',
                    atLeastOne: 'Doit être au moins 1.',
                    author: 'Auteur',
                    authorisationRequested: 'Autorisation demandée',
                    avatar: 'avatar',
                    back: 'Retour',
                    banknoteReader: 'Lecteur de billets',
                    bbd: 'DLC',
                    bbdOutdated: 'DLC dépassée',
                    bbdSoonOutdated: 'DLC bientôt dépassée',
                    bbdWithDate: 'DLC : {{date}}',
                    belgium: 'Belgique',
                    block: 'Bloquer',
                    blockCard: 'Bloquer la carte',
                    blockedCards: 'Cartes bloquées',
                    brand: 'Marque',
                    buildingFloor: 'Bâtiment / étage',
                    cancelledFeminine: 'Annulée',
                    cancellingOrder: 'Annulation commande',
                    cancelOrder: 'Annuler la commande',
                    cancelReason: 'Motif de l’annulation',
                    carbs: 'Glucides',
                    card: 'Carte',
                    cardAlreadyBlocked: 'La carte est déjà bloquée.',
                    cardNumber: 'Numéro de carte',
                    cardNumberAlreadyInUse:
                        'Le numméro de carte est déjà utilisée.',
                    cardType: 'Type de carte',
                    cartDiscount: 'Réduction panier',
                    cash: 'Espèce',
                    catalogue: 'Catalogue',
                    categories: 'Catégories',
                    category: 'Catégorie',
                    channelNotConnected: 'Canal non connecté',
                    chooseMachineType: 'Veuillez choisir le type de machine',
                    chooseManager: 'Veuillez choisir un gestionnaire',
                    chooseSelection: 'Veuillez choisir une sélection',
                    city: 'Ville',
                    clickOnMicrowave:
                        'Cliquez sur un micro-onde pour l’activer / désactiver.',
                    client: 'Client',
                    clientCreation: 'Création client',
                    clientFilter: 'Filtre client',
                    clients: 'Clients',
                    closedLocker: 'Casier fermé',
                    closingTime: 'Heure de fermeture',
                    codes: 'Codes',
                    coinAcceptor: 'Monnayeur',
                    column: 'Colonne',
                    commercialInformation: 'Informations commerciales',
                    communicationLost: 'Communication perdue',
                    confirm: 'Valider',
                    confirmDeletionText:
                        'Êtes-vous sûr de supprimer définitivement ?',
                    confirmDeletionTitle: 'Confirmation de la suppression',
                    connectionToTerminal: 'Connexion vers borne',
                    contact: 'Contacter',
                    contacted: 'Contacté',
                    contactNumber: 'Numéro de contact',
                    containsIcoupon: 'Contient iCoupon',
                    contract: 'Contrat',
                    contractDuration: 'Durée du contrat (mois)',
                    contractNumber: 'Numéro de contrat',
                    cookingRequirements: 'Besoin de cuisson',
                    cookingTemperature: 'Température de cuisson',
                    cookingTime: 'Temps de cuisson',
                    copied: 'Copié dans le presse-papier.',
                    correct: 'Correcte',
                    country: 'Pays',
                    created: 'Créé avec succès !',
                    creation: 'Création',
                    creationDate: 'Date de création',
                    creditCard: 'Carte de crédit',
                    customerService: 'Service client',
                    customerServiceMessage:
                        'Vous rencontrez un problème ? Créez un ticket sur <link />. Vous pourrez suivre son avancée.',
                    customisedFeminine: 'Personnalisée',
                    date: 'Date',
                    dateEnd: 'Date de fin',
                    datePassage: 'Date de passage',
                    datePassageInfo: 'Date de passage : {{date}}',
                    dates: 'Dates',
                    dateSignature: 'Date de signature',
                    dateStart: 'Date de début',
                    dayEnd: 'Jour de fin',
                    dayEndError:
                        'La date de fin est inférieur à la date de début.',
                    dayStart: 'Jour de début',
                    dayStartError: 'La date de début dépasse la date de fin.',
                    deactivate: 'Désactiver',
                    deactivated: 'Désactivé',
                    defaultLanguageCustomer: 'Langue client par défaut',
                    defaultLanguageIntervenor: 'Langue intervenant par défaut',
                    delete: 'Supprimer',
                    deleted: 'Supprimé avec succès !',
                    deliveries: 'Livraisons',
                    deliveryMan: 'Livreur',
                    deliveryManCreation: 'Création livreur',
                    deliveryMen: 'Livreurs',
                    description: 'Description',
                    desired: 'Désiré',
                    destocking: 'Déstockage',
                    diagnostic: 'Diagnostic',
                    discount: 'Réduction',
                    discounts: 'Promotions',
                    discountsPriorities: 'Priorités promotions',
                    dispensingCancelled: 'Distribution annulée',
                    dispute: 'Contestation',
                    disputedFeminine: 'Contestée',
                    disputeState: 'Statut contestation',
                    distributionSpeed: 'Vitesse de distribution',
                    distributor: 'Distributeur',
                    divider: 'Séparateur',
                    domainName: 'Nom de domaine',
                    doorOpen: 'Porte ouverte',
                    download: 'Télécharger',
                    dropFileHere: 'Déposez le fichier ici.',
                    duplicate: 'Dupliquer',
                    elevatorFault: 'Défaut de l’ascenseur',
                    eligibleFridgeWeight: 'Éligible frigo poids',
                    eligibleLuncheonVouchers: 'Éligible ticket restaurant',
                    email: 'Courriel',
                    emailAlreadyInUse: 'Ce courriel est déjà utilisé.',
                    emailError: 'Un courriel valide est requis.',
                    emailResetPassword:
                        'Courriel envoyé pour réinitialiser votre mot de passe !',
                    emailSignatory: 'Courriel signataire',
                    employerContribution: 'Participation employeur',
                    empty: 'Vide',
                    encodedProducts: 'Produits encodés',
                    endTime: 'Heure de fin',
                    energy: 'Énergie',
                    english: 'Anglais',
                    errorAlarmRedLed:
                        'La minuterie de l’alarme rouge doit être supérieure à la minuterie de LED jaune.',
                    errorAlarmYellowLedOne:
                        'La minuterie de l’alarme jaune doit être réglée à un minimum de 5 secondes après le temps d’ouverture de la porte.',
                    errorAlarmYellowLedTwo:
                        'La minuterie de l’alarme jaune doit être réglée à un minimum de 5 secondes avant la minuterie de la LED rouge.',
                    errorDiffTempTooHighOne:
                        'Le différentiel doit être inférieur au seuil de température élevé moins la température réglée.',
                    errorDiffTempTooHighTwo:
                        'Le différentiel doit être inférieur à la température réglée soustrait par le seuil de température basse.',
                    errorFieldRequired: 'Ce champ est requis.',
                    errorHighTempThresh:
                        'Le seuil de température haute doit être supérieur au seuil de température basse et ne doit pas dépasser 25 °C.',
                    errorImportNumeric: 'Ce champs doit être un nombre.',
                    errorImportString: 'Ce champs ne doit pas être un nombre.',
                    errorInUse: 'Cet objet est actuellement utilisé.',
                    errorLowTempThreshTooHigh:
                        'Le seuil de température basse doit être inférieur au seuil de température haute.',
                    errorLowTempThreshTooLow:
                        'Le seuil de température basse doit être inférieur à la température réglée additionnée du différentiel.',
                    errorOpenDoorTimer:
                        'La minuterie de déverrouillage de la porte doit être réglée sur au moins 5 secondes et doit être inférieure d’au moins 5 secondes à la minuterie de l’alarme jaune.',
                    errorPhoto: 'Une photo est requise.',
                    errorSetpointTempTooHigh:
                        'La température doit être inférieure au seuil de température haut soustrait du différentiel.',
                    errorSetpointTempTooLow:
                        'La température doit être supérieure au seuil de température basse additionné du différentiel.',
                    errorTempNotBetweenSetLimits:
                        'La température doit être comprise entre -30 et 23 °C inclus.',
                    errorTryLater:
                        'Une erreur est survenue, veuillez réessayer plus tard.',
                    errorUserCreation:
                        'Une erreur est survenue à la création de l’utilisateur Konsole.',
                    excelPercentage: '#,#0.0" %"',
                    excelPrice: '#,##0.00" €"',
                    excelPriceWeight: '#,##0.00" € / Kg"',
                    expiredFeminine: 'Expirée',
                    export: 'Exporter',
                    exportInPreparation: 'L’export est en préparation…',
                    fats: 'Matières grasses',
                    fibres: 'Fibres',
                    fieldRequiredFill:
                        'Veuillez remplir tous les champs requis.',
                    fileSizeError: 'Taille du fichier trop gros.',
                    fill: 'Plein',
                    filters: 'Filtres',
                    final: 'Final',
                    firstName: 'Prénom',
                    firstNameSignatory: 'Prénom signataire',
                    forgottenPassword: 'Mot de passe oublié ?',
                    france: 'France',
                    french: 'Français',
                    friday: 'Vendredi',
                    fridgeRfid: 'e-Frigo',
                    fridgeWeight: 'Frigo à poids',
                    from: 'Du',
                    furtherInformation: 'Informations complémentaires',
                    general: 'Général',
                    generalInformation: 'Informations générales',
                    generate: 'Générer',
                    germany: 'Allemagne',
                    globalInformation: 'Informations globales',
                    groupBy: 'Grouper par',
                    grouped: 'Groupé',
                    history: 'Historique',
                    idCardReader: 'Lecteur de carte d’identité',
                    identifier: 'Identifiant',
                    impersonate: 'Usurpation de l’identité',
                    impersonateInstructions:
                        'Faites un clic droit sur <link /> et ouvrez-le dans une nouvelle fenêtre de navigation privée. Voilà, vous avez usurpé l’identité !',
                    import: 'Import',
                    imported: 'Importé avec succès !',
                    importModificationText:
                        'Êtes-vous sûr de vouloir changer de type d’import ? Toute modification sera perdue.',
                    importModificationTitle: 'Modification de l’import',
                    importProducts: 'Import de produits',
                    importProductsLimited:
                        'Import de produits limité à {{number}}',
                    importVerb: 'Importer',
                    inactive: 'Inactif',
                    incidents: 'Incidents',
                    incidentsRabbitmq: 'Incidents RabbitMQ',
                    inFitsAndStarts: 'Par à-coups',
                    infoOutdated:
                        'Les DLC dépassées ne sont pas prises en compte dans la date de passage sélectionnée.',
                    informative: 'Informatif',
                    inPreparation: 'En préparation',
                    inProgress: 'En cours…',
                    instructions: 'Instructions',
                    internet: 'Internet',
                    interventions: 'Interventions',
                    ipAddress: 'Adresse IP',
                    italy: 'Italie',
                    konvivesLink: 'Lien Konvives',
                    lastActivityDate: 'Dernière date d’activité',
                    lastLoss: 'Dernière perte :',
                    lastName: 'Nom',
                    lastNameSignatory: 'Nom signataire',
                    lastSign: 'Dernier signe :',
                    lifespan: 'Durée de vie (jours)',
                    line: 'Ligne',
                    loading: 'Chargement en cours…',
                    locationErrorDuplicate:
                        'Un numéro de sélection est dupliqué.',
                    locationErrorEmpty: 'Une sélection est vide.',
                    locationErrorMotor: 'Deux moteurs ont les mêmes positions.',
                    locationErrorPlanogramName: 'Nom du planogramme manquant.',
                    locationErrorPlanogramOrder:
                        'Ordre du planogramme manquant.',
                    lockerCold: 'Casier réfrigéré',
                    lockerDry: 'Casier sec',
                    logIn: 'Se connecter',
                    login: 'Connexion',
                    logistics: 'Logistique',
                    logOut: 'Se déconnecter',
                    luxembourg: 'Luxembourg',
                    machine: 'Machine',
                    machineChoice: 'Choix de la machine',
                    machineChoiceDetails:
                        'Choisissez la machine sur laquelle créer le planogramme.',
                    machineOptionsAndTechnicalData:
                        'Données techniques / options machines',
                    machines: 'Machines',
                    machineType: 'Type de machine',
                    managementSelection: 'Gestion des sélections',
                    managementTray: 'Gestion des plateaux',
                    manager: 'Gestionnaire',
                    managerCreation: 'Création gestionnaire',
                    managerEditionText:
                        'Êtes-vous sûr de vouloir changer de gestionnaire ? Toute modification sera perdue.',
                    managerEditionTitle: 'Édition gestionnaire',
                    managerItemCode: 'Code article gestionnaire',
                    managers: 'Gestionnaires',
                    manual: 'Manuelle',
                    marketingImagesAndVideos: 'Images / vidéos marketing',
                    maximum: 'Maximum',
                    mealVoucher: 'Ticket restaurant',
                    menuNotTaken: 'Menu pas pris en compte',
                    menus: 'Menus',
                    microwave: 'Micro-onde',
                    microwaveCreation: 'Création micro-onde',
                    microwaves: 'Micro-ondes',
                    mifareCode: 'Code MIFARE',
                    mifareCodeAlreadyInUse: 'Le code MIFARE est déjà utilisé.',
                    model: 'Modèle',
                    modification: 'Modification',
                    modificationDate: 'Date de modification',
                    modifyProductInfo: 'Modifier les informations produits',
                    modifyTechnicalData: 'Modifier les données techniques',
                    monday: 'Lundi',
                    month: 'Mois',
                    motor: 'Moteur',
                    motorActivation: 'Activation moteur après distribution',
                    motorFailure: 'Échec moteur',
                    name: 'Nom',
                    navigationBar: 'Barre de navigation',
                    netherlands: 'Pays-Bas',
                    newClient: 'Nouveau client',
                    newDeliveryMan: 'Nouveau livreur',
                    newManager: 'Nouveau gestionnaire',
                    newMicrowave: 'Nouveau micro-onde',
                    newNamePriceTable: 'Nouveau nom de la table de prix',
                    newOrder: 'Nouvelle commande',
                    newProduct: 'Nouveau produit',
                    newProfile: 'Nouveau profil',
                    newReport: 'Nouveau rapport',
                    newService: 'Nouveau service',
                    newSite: 'Nouveau site',
                    newSupplier: 'Nouveau fournisseur',
                    newTable: 'Nouvelle table',
                    newTechnician: 'Nouveau technicien',
                    next: 'Suivant',
                    no: 'Non',
                    noAdmin: 'Non admin',
                    noBlockedCardAvailable: 'Aucune carte bloquée trouvée.',
                    noChange: 'Aucun changement.',
                    noClientAvailable: 'Aucun client disponible.',
                    noDeliveryManAvailable: 'Aucun livreur disponible.',
                    noDiagnosticAvailable: 'Aucun diagnostique disponible.',
                    noEmployerContributionAvailable:
                        'Aucune participation employeur disponible.',
                    noManagerAvailable: 'Aucun gestionnaire disponible.',
                    noMicrowaveAvailable: 'Aucun micro-onde disponible.',
                    none: 'Aucun',
                    noOrderAvailable: 'Aucune commande disponible.',
                    noPlanogramAvailable: 'Aucun planogramme disponible.',
                    noProductAvailable: 'Aucun produit disponible.',
                    noProductSelected: 'Aucun produit sélectionné.',
                    noProfileAvailable: 'Aucun profil disponible.',
                    noRefillAvailable: 'Aucun rechargement disponible.',
                    noReportAvailable: 'Aucun rapport disponible.',
                    noResultAvailable: 'Aucun résultat disponible.',
                    noSaleAvailable: 'Aucune vente disponible.',
                    noServiceAvailable: 'Aucun service disponible.',
                    noSiteAvailable: 'Aucun site disponible.',
                    noSupplierAvailable: 'Aucun fournisseur disponible.',
                    noTechnicianAvailable: 'Aucun technicien disponible.',
                    noUserAvailable: 'Aucun utilisateur disponible.',
                    numberProducts: 'Nombre de produits incorrect',
                    nutritionalValues: 'Valeurs nutritionnelles',
                    onDelivery: 'En livraison',
                    onlyShortBbd: 'Uniquement les DLC courtes',
                    openingTime: 'Heure d’ouverture',
                    openingTimes: 'Horaires d’ouverture',
                    openLocker: 'Ouvrir le casier',
                    openLockerConfirmation:
                        'Êtes-vous sûr d’ouvrir le casier {{mapping}} ?',
                    operations: 'Opérations',
                    order: 'Commande',
                    orderCreation: 'Création commande',
                    orderNotFound: 'Commande introuvable',
                    orderNumber: 'Commande n°{{number}}',
                    orders: 'Commandes',
                    other: 'Autre',
                    park: 'Parc',
                    password: 'Mot de passe',
                    passwordConfirm: 'Confirmez le mot de passe',
                    passwordNew: 'Nouveau mot de passe',
                    passwordResetAction: 'Réinitialiser le mot de passe',
                    passwordResetTitle: 'Réinitialisation du mot de passe',
                    passwordRuleCommon:
                        'Les mots de passe trop communs/évidents sont également bloqués.',
                    passwordRuleIntro:
                        'Votre mot de passe doit contenir au minimum :',
                    passwordRuleLength: '12 caractères minimum',
                    passwordRuleLowercase: '2 lettres minuscules',
                    passwordRuleNumber: '2 chiffres',
                    passwordRuleSpecial: '2 caractères spéciaux',
                    passwordRuleUppercase: '2 lettres majuscules',
                    passwordsDoNotMatch:
                        'Les mots de passe ne correspondent pas.',
                    passwordsMustBeStronger:
                        'Le mot de passe doit être plus robuste.',
                    paymentMethod: 'Méthode de paiement',
                    pending: 'En attente',
                    phone: 'Téléphone',
                    phoneSignatory: 'Téléphone signataire',
                    photo: 'Photo',
                    planogramCreate: 'Créer un planogramme',
                    planogramDeleteAsk:
                        'Êtes-vous sûr de vouloir supprimer ce planogramme ?',
                    planogramOrder: 'Ordre',
                    planograms: 'Planogrammes',
                    port: 'Port',
                    portugal: 'Portugal',
                    position: 'Position',
                    postalCode: 'Code postal',
                    power: 'Courant',
                    preferLibreOffice:
                        'Pour une utilisation optimale, veuillez préférer LibreOffice.',
                    price: 'Prix',
                    priceKonvives: 'Prix Konvives',
                    pricePrivateCard: 'Prix carte privative',
                    priceStandard: 'Prix standard',
                    priceTableCreation: 'Création table de prix',
                    priceTables: 'Tables de prix',
                    priceUnit: 'Prix unitaire',
                    priceWeight: 'Prix au poids',
                    printer: 'Imprimante',
                    privateCard: 'Carte privative',
                    problem: 'Problème',
                    product: 'Produit',
                    productChange: 'Changement de produit',
                    productCreation: 'Création produit',
                    productExpired: 'Produit périmé',
                    productListErrors: 'Liste des erreurs produits',
                    products: 'Produits',
                    productsDistributed: 'Produits distribués',
                    productsExcluded: 'Produits à exclure',
                    productsNotDistributed: 'Produits non distribués',
                    productSoldOut: 'Produit épuisé',
                    profile: 'Profil',
                    profileCreation: 'Création profil',
                    profiles: 'Profils',
                    proteins: 'Protéines',
                    pspReference: 'Référence PSP',
                    purchaseInvoice: 'Facture d’achat',
                    purchasePrice: 'Prix d’achat',
                    purchasePriceAsc: 'Prix d’achat (croissant)',
                    purchasePriceDesc: 'Prix d’achat (décroissant)',
                    quantity: 'Quantité',
                    quantityAsc: 'Quantité (croissant)',
                    quantityDesc: 'Quantité (décroissant)',
                    queueFull: 'File d’attente pleine',
                    reading: 'Lecture',
                    readyFeminine: 'Prête',
                    reason: 'Raison',
                    rebootApt: 'Redémarrer le TPA',
                    rebootAptConfirmation:
                        'Êtes-vous sûr de redémarrer le TPA ?',
                    receipt: 'Ticket de caisse',
                    recommended: 'Recommandé',
                    recommendedDeliveryTime: 'Heure de livraison recommandée',
                    recreditation: 'Recréditation',
                    refill: 'Rechargement',
                    refills: 'Rechargements',
                    refund: 'Remboursement',
                    refundedFeminine: 'Remboursée',
                    refunds: 'Remboursements',
                    refundVerb: 'Rembourser',
                    refuse: 'Refuser',
                    refused: 'Refusé',
                    refusedFeminine: 'Refusée',
                    removedFeminine: 'Retirée',
                    rename: 'Renommer',
                    reportQueue: 'Rapport dans la file d’attente !',
                    reports: 'Rapports',
                    reportsGeneratedKept:
                        'Les rapports générés sont conservés pendant 30 jours avant d’être supprimés.',
                    resetPassword: 'Réinitialision mot de passe',
                    resetPasswordInstruction:
                        'Veuillez renseigner votre courriel. Vous recevrez un lien pour réinitialiser votre mot de passe.',
                    resetSelectionPriceWeight:
                        'Réinitialisation sélections produit',
                    resetSelectionPriceWeightTextPlural:
                        'Les sélections des produits basculés avec le prix au poids présents dans les machines seront vidées.',
                    resetSelectionPriceWeightTextSingular:
                        'Les sélections du produit présent dans les machines seront vidées.',
                    restartComputer: 'Redémarrer l’ordinateur',
                    restartComputerConfirmation:
                        'Êtes-vous sûr de redémarrer l’ordinateur ?',
                    retrievedBySomeoneElse: 'Récupérée (autre)',
                    retrievedFeminine: 'Récupérée',
                    sale: 'Vente',
                    saleReport: 'Rapport de vente',
                    saleReportCreation: 'Création rapport de vente',
                    saleReports: 'Rapports de vente',
                    sales: 'Ventes',
                    salesLog: 'Journal de vente',
                    salesLogCreation: 'Création journal de vente',
                    saleStatus: 'Statut vente',
                    salt: 'Sel',
                    saturatedFat: 'Acides gras saturés',
                    saturday: 'Samedi',
                    screen: 'Écran',
                    searchAddress: 'Chercher adresse',
                    sector: 'Secteur',
                    selectCancelOrderReason:
                        'Sélectionner le motif de refus de la commande',
                    selectClientSiteOrTerminal:
                        'Sélectionner un client, un site ou une borne.',
                    selection: 'Sélection',
                    selectionNotConfigured: 'Sélection non configurée',
                    selectionNumber: 'Numéro de sélection',
                    selectKonviveOrPhone:
                        'Sélectionner un Konvive ou ajouter un téléphone',
                    selectLockerToOpen: 'Sélectionner le casier à ouvrir',
                    selectSiteDelivery: 'Sélectionner un site de livraison',
                    selectSiteOrTerminal:
                        'Veuillez sélectionner un site ou une borne.',
                    selfService: 'Libre-service',
                    sent: 'Envoyé avec succès !',
                    serialNumber: 'Numéro de série',
                    service: 'Service',
                    serviceCreation: 'Création service',
                    serviceFilter: 'Filtre service',
                    serviceReport: 'Rapport de service',
                    serviceReportCreation: 'Création rapport de service',
                    serviceReports: 'Rapports de service',
                    services: 'Services',
                    settings: 'Paramètres',
                    signatory: 'Signataire',
                    signature: 'Signature',
                    site: 'Site',
                    siteCreation: 'Création site',
                    siteFilter: 'Filtre site',
                    sites: 'Sites',
                    size: 'Taille',
                    sizeInform: 'Redimensionnez les sélections.',
                    sortBy: 'Trier par',
                    spain: 'Espagne',
                    spanish: 'Espagnol',
                    split: 'Séparé',
                    standard: 'Standard',
                    startTime: 'Heure de début',
                    status: 'Statut',
                    steps: 'Étape',
                    stock: 'Stock',
                    stockMachines: 'Stock machines',
                    stockMaximum: 'Stock maximum',
                    stockRecommended: 'Stock recommandé',
                    stockReport: 'Rapport de stock',
                    subcategory: 'Sous-catégorie',
                    sugar: 'Sucre',
                    sunday: 'Dimanche',
                    supervisor: 'Responsable',
                    supplier: 'Fournisseur',
                    supplierCreation: 'Création fournisseur',
                    supplierFilter: 'Filtre fournisseur',
                    suppliers: 'Fournisseurs',
                    supply: 'Approvisionnement',
                    supplyDays: 'Jours d’approvisionnement',
                    supplyReport: 'Rapport d’approvisionnement',
                    support: 'Assistance',
                    supportEmail: 'Courriel d’assistance',
                    supportPhone: 'Téléphone d’assistance',
                    switchInactive: 'Passer en inactif',
                    switchPending: 'Passer en attente',
                    switzerland: 'Suisse',
                    table: 'Table',
                    technician: 'Technicien',
                    technicianCreation: 'Création technicien',
                    technicians: 'Techniciens',
                    terminal: 'Borne',
                    terminalFilter: 'Filtre borne',
                    terminals: 'Bornes',
                    text: 'Texte',
                    theme: 'Thème',
                    thisLink: 'ce lien',
                    thursday: 'Jeudi',
                    ticket: 'Ticket',
                    timeEndError:
                        'L’heure de fin est inférieur à l’heure de début.',
                    timeSlotNumber: 'Plage {{number}}',
                    timeSlotOverlap:
                        'La plage horaire ne doit pas chevaucher une autre plage.',
                    timeSlots: 'Plages horaires',
                    timeStartError: 'L’heure de début dépasse l’heure de fin.',
                    to: 'au',
                    toRefill: 'À recharger',
                    total: 'Total',
                    totalRefund: 'Remboursement total :',
                    transactions: 'Transactions',
                    tuesday: 'Mardi',
                    turnoverWithoutVat: 'Chiffre d’affaires (HT)',
                    turnoverWithoutVatAsc:
                        'Chiffre d’affaires (HT) (croissant)',
                    turnoverWithoutVatDesc:
                        'Chiffre d’affaires (HT) (décroissant)',
                    turnoverWithVat: 'Chiffre d’affaires (TTC)',
                    type: 'Type',
                    unblockCard: 'Débloquer la carte',
                    unitedKingdom: 'Royaume-Uni',
                    unitedStateOfAmerica: 'États-Unis d’Amérique',
                    units: 'Unités',
                    unknownError: 'Erreur inconnue',
                    unlockHatch: 'Dévérouiller la trappe',
                    unlockHatchConfirmation:
                        'Êtes-vous sûr de dévérouiller la trappe ?',
                    update: 'Mettre à jour',
                    updated: 'Mis à jour avec succès !',
                    updatedLightningSchedules:
                        'Horaires d’éclairage mis à jour.',
                    ups: 'Onduleur',
                    userInformation: 'Informations utilisateur',
                    userKonsole: 'Utilisateur Konsole',
                    username: 'Nom d’utilisateur',
                    usernameAlreadyInUse:
                        'Ce nom d’utilisateur est déjà utilisé.',
                    usernameOrPasswordIncorrect:
                        'Nom d’utilisateur ou mot de passe incorrect.',
                    users: 'Utilisateurs',
                    usersKonsole: 'Utilisateurs Konsole',
                    usersKonsoleCreation: 'Création utilisateur Konsole',
                    usersNew: 'Nouvel utilisateur',
                    vat: 'TVA',
                    volume: 'Volume',
                    wednesday: 'Mercredi',
                    weight: 'Poids',
                    wrongPrice: 'Mauvais prix',
                    wrongProduct: 'Mauvais produit',
                    yes: 'Oui',
                    zone: 'Zone',

                    // Old
                    '# of Sales': '# de ventes',
                    '12 last days': '12 derniers jours',
                    '12 last months': '12 derniers mois',
                    '12 last weeks': '12 dernières semaines',
                    'Accessible machines': 'Machines accessibles',
                    'Activate?': 'Activé?',
                    'Add new consumer': 'Ajouter un convive',
                    'Add new machine': 'Ajouter une machine',
                    'Add new marketing image': 'Ajouter une image marketing',
                    'Add new promotion': 'Ajouter une promotion',
                    Added: 'Ajoutés',
                    'Added products': 'Produits ajoutés',
                    'Additional info': 'Infos supplémentaires',
                    'After refund credit': 'Crédit après remboursement',
                    Alarm: 'Alarme',
                    All: 'Tous',
                    'All values are in':
                        'Toutes les valeurs sont sur le fuseau',
                    'Antenna high': 'Antenne haute',
                    'Antenna low': 'Antenne basse',
                    'Antenna middle 1': 'Antenne milieu 1',
                    'Antenna middle 2': 'Antenne milieu 2',
                    'Antenna state': 'Etat antenne',
                    'Are you sure you want to delete this encoded product?':
                        'Êtes vous sûr de vouloir supprimer ce produit encodé?',
                    'Are you sure you want to delete this machine user?':
                        'Êtes vous sûr de vouloir supprimer ce convive?',
                    'Are you sure you want to delete this machine?':
                        'Êtes vous sûr de vouloir supprimer cette machine?',
                    'Ask for password reset':
                        'Demande de réinitialisation de mot de passe',
                    Average: 'Moyenne de',
                    'Before refund credit': 'Crédit avant remboursement',
                    'Best before date': 'DLC',
                    'Best before date filter': 'Filtre DLC',
                    'Best before date list': 'Liste DLCs',
                    'Best vending machines': 'Top 5 machines en CA',
                    'Best vending products':
                        'Top 5 produits en nombre de ventes',
                    'Build date': 'Date de construction',
                    'Card number': 'Numéro de carte',
                    'Category list': 'Liste des catégories',
                    'Chart comparison': 'Graphique comparatif',
                    'Choose which list you want to modify':
                        'Choisissez quelle liste vous souhaitez modifier',
                    'Closing time': 'Heure fermeture',
                    'Cold chain': 'Chaîne du froid',
                    'Company registration number': 'SIRET',
                    'compared to last month': 'comparé au mois dernier',
                    'Composed by': 'Composé de',
                    'Compressor start counter':
                        'Compteur démarrage compresseur',
                    'Connected machines': 'Machines en ligne',
                    'Connexion type': 'Type de connexion',
                    'Contestation reason': 'Raison contestation',
                    'Creation date': 'Date de création',
                    Credit: 'Crédit',
                    'Credit card': 'CB',
                    Currency: 'Devise',
                    'Current logo': 'Logo actuel',
                    'Current priority': 'Priorité actuelle',
                    'Customer name': 'Nom client',
                    'Customer name filter': 'Filtre nom client',
                    'Customer names': 'Noms clients',
                    'D day': 'Jour J',
                    'D+': 'J+',
                    'Date range': 'Plage de dates',
                    'Date time': 'Date et heure',
                    'Dates lock': 'Blocage DLC',
                    Days: 'Jours',
                    'Defrost start counter': 'Compteur démarrage dégivrage',
                    Delete: 'Suppression',
                    'Delivery man': 'Livreur',
                    'Delivery man filter': 'Filtre livreur',
                    Description: 'Description',
                    'Destocking date': 'Date destockage',
                    Details: 'Details',
                    'Different client/machines': 'Clients/machines différents',
                    'Differential set': 'Différentiel réglé',
                    'Digital luncheon voucher': 'TRD',
                    Discount: 'Promotions',
                    'Discount amount': 'Montant réduction',
                    Dispute: 'Contestation',
                    'Distributor volume': 'Volume du distributeur',
                    'Download file model': 'Télécharger fichier modèle',
                    'Drag and drop an image here or click':
                        'Glisser-déposer une image ici ou cliquez',
                    'Drag and drop your profile picture here or click':
                        'Glisser-déposer votre photo de profil ici ou cliquez',
                    Duration: 'Durée',
                    'E-mail': 'E-mail',
                    'E-mail address': 'Adresse e-mail',
                    'Employer participation': 'Participation employeur',
                    'Enabled?': 'Activé?',
                    Encoding: 'Encodage',
                    'Encoding date': 'Date d’encodage',
                    'Encoding reports': 'Rapports d’encodage',
                    'End date': 'Date fin',
                    'End time': 'Date/heure fin',
                    EPC: 'EPC',
                    'Fan start counter': 'Compteur démarrage ventilateur',
                    'Fidelity points': 'Points de fidélité',
                    'First name': 'Prénom',
                    Friday: 'Vendredi',
                    From: 'Du',
                    'Global info': 'Informations globales',
                    'High stock check time': 'Heure verif. stock haut',
                    'High temperature threshold': 'Seuil température haut',
                    'High threshold': 'Seuil haut',
                    'ID Label gun': 'ID PDA',
                    'Import new profile picture':
                        'Importer une nouvelle photo de profil',
                    'Import several customers': 'Importer plusieurs convives',
                    'Import several encoded products':
                        'Importer produits encodés',
                    'In menu': 'En menu',
                    'Incident priority filter': 'Filtre priorité incident',
                    'Incident status': 'Statut incident',
                    'Individual products': 'Produits individuels',
                    'Infos related to promotion type':
                        'Infos liées au type de la promo',
                    'Installation date': 'Date d’installation',
                    Kind: 'Type',
                    'Label gun': 'Étiqueteuse',
                    'Last card digits/ID': 'Derniers digits carte/ID',
                    'Last name': 'Nom',
                    'Last technical values received':
                        'Dernières données techniques reçues',
                    'Low temperature threshold': 'Seuil température bas',
                    'Low threshold': 'Seuil bas',
                    'Machine name': 'Nom de la machine',
                    'Machine user': 'Convive',
                    'Machine users form': 'Formulaire convives',
                    'Machine(s)': 'Machine(s)',
                    'Machines filter': 'Filtre machines',
                    'Machines form': 'Formulaire machines',
                    'Machines list': 'Liste machines',
                    'Machines map': 'Carte des machines',
                    Maintenance: 'Maintenance',
                    'Marketing image form': 'Formulaire marketing image',
                    'Marketing images': 'Images marketing',
                    'Mass import encoded products':
                        'Import en masse de produits encodés',
                    'Mass import machine users': 'Import en masse de convives',
                    'Max amount': 'Montant max',
                    'Max number participation': 'Nombre max. participations',
                    'Max number participations': 'Nombre max participations',
                    'Max participations': 'Participations max',
                    'Max products': 'Produits max',
                    'Maximum number of products': 'Nombre maximum de produits',
                    'Menu by category': 'Menu par catégories',
                    'Menu photo': 'Photo menu',
                    'Menu price': 'Prix menu',
                    'Menu pricing': 'Menu au prix de',
                    Message: 'Message',
                    'Min amount': 'Montant min',
                    'Minimum amount': 'Montant minimum',
                    'Minimum credit': 'Crédit minimum',
                    'Mobile app': 'App mobile',
                    Mode: 'Mode',
                    'Mode(s) of payment': 'Méthode(s) de paiement',
                    Monday: 'Lundi',
                    'Monthly results all machines': 'CA mois (TTC)',
                    Name: 'Nom',
                    'Navigate technical data': 'Voir données techniques',
                    'Nb products': 'Nb produits',
                    'Nb products sold all machines': 'Nb produits vendus',
                    'Nb transactions all machines': 'Nb transactions',
                    'Nb. of sales': 'Nb. ventes',
                    'Nb. of transactions': 'N° de transactions',
                    'Nb. products': 'Nb. produits',
                    'New priority': 'Nouvelle priorité',
                    No: 'Non',
                    'No delivery found': 'Aucune livraison trouvée',
                    'No encoded product found': 'Aucun produit encodé trouvé',
                    'No encoding report found':
                        'Aucun rapport d’incident trouvé',
                    'No incident found': 'Aucun incident trouvé',
                    'No machine found': 'Aucune machine trouvée',
                    'No maintenance found': 'Aucune maintenance trouvée',
                    'No media for this promotion':
                        'Aucun media pour cette promotion',
                    'No promotion found': 'Aucune promotion trouvée',
                    'No rabbitMQ incident found':
                        'Aucun incident RabbitMQ trouvé',
                    'No refund found': 'Aucun remboursement trouvé',
                    'Number of products': 'Stock Produits',
                    'Number of products required': 'Nombre produit(s) requis',
                    'Number of products sold': 'Nombre de produits vendus',
                    'Number of transactions': 'Nombre de transactions',
                    Offline: 'Hors ligne',
                    'Open door counter': 'Compteur ouverture porte',
                    'Opening hours': 'Horaires d’ouverture',
                    'Opening time': 'Heure ouverture',
                    Operator: 'Gestionnaire',
                    'Operator list': 'Liste des gestionnaires',
                    'Operator name': 'Nom du gestionnaire',
                    'Operator price table': 'Table des prix gestionnaire',
                    Operators: 'Gestionnaires',
                    'Operators categories': 'Catégories gestionnaires',
                    'Operators filter': 'Filtre gestionnaires',
                    'Origin of creation': 'Origine création',
                    'out of': 'sur',
                    'Paiement method': 'Méthode de paiement',
                    'Passed date products': 'DLC dépassée',
                    'Payment method list': 'Liste méthodes paiement',
                    'Payment method list *': 'Liste méthodes paiement *',
                    'Percentage stock alarm': 'Pourcentage stock alarme',
                    'Percentage stock high': 'Pourcentage stock haut',
                    'Person name': 'Nom personne',
                    'Phone number': 'Numéro de téléphone',
                    'Price table': 'Table des prix',
                    'Primary color': 'Couleur primaire',
                    'Printer state': 'Etat imprimante',
                    'Priorities by machine': 'Priorités par machine',
                    Priority: 'Priorité',
                    'Private card': 'Carte privative',
                    'Private ID': 'ID privé',
                    Product: 'Produit',
                    'Product(s)': 'Produit(s)',
                    Products: 'Produits',
                    'Products categories': 'Catégories produits',
                    'Products list': 'Liste des produits',
                    'Products sold': 'Produits vendus',
                    'Products sub-categories': 'Sous-catégories produits',
                    Profile: 'Mon profil',
                    'Promo type list': 'Liste types promo',
                    'Promotion form': 'Formulaire promotion',
                    'Promotion name': 'Nom promotion',
                    'Promotion programming': 'Programmation de la promotion',
                    'Promotion status': 'Statut promotion',
                    'Promotion type': 'Type promotion',
                    Promotions: 'Promotions',
                    'Promotions priorities': 'Priorités des promos',
                    'Provenance machine': 'Machine de provenance',
                    Provider: 'Fournisseur',
                    Quantity: 'Quantité',
                    'Quantity of products': 'Nombre de produits',
                    Reason: 'Raison',
                    Recurrence: 'Récurrence',
                    Reduction: 'Réduction',
                    'Reduction amount': 'Montant réduction',
                    Removed: 'Retirés',
                    'Removed products': 'Produits retirés',
                    Results: 'Résultats',
                    Revenues: 'CA',
                    'Same client/machines': 'Mêmes clients/machines',
                    Saturday: 'Samedi',
                    'Save details': 'Enregistrer',
                    'Screen time': 'Durée affichage',
                    'Search card number': 'Rechercher numéro de carte',
                    'Search first or last name': 'Recherche nom ou prénom',
                    'Search last card digits':
                        'Recherche derniers digits carte',
                    'Search machine name': 'Rechercher nom machine',
                    'Search person name': 'Rechercher nom personne',
                    'Search products name': 'Rechercher nom produit',
                    'Search transaction number': 'Rechercher n° transaction',
                    'second(s)': 'seconde(s)',
                    'Secondary color': 'Couleur secondaire',
                    Send: 'Valider',
                    'Site name': 'Nom du site',
                    'Site types': 'Types de site',
                    'Sites filter': 'Filtre sites',
                    'Software version': 'Version logicielle',
                    'Standby photo': 'Photo veille',
                    'Start date': 'Date début',
                    'Start time': 'Date/heure début',
                    Status: 'Statut',
                    'Stock high': 'Stock haut',
                    'Stock in percentage': 'Stock en pourcentage',
                    'Stock low': 'Stock bas',
                    Sunday: 'Dimanche',
                    Supply: 'Approvisionnement',
                    'Supply days *': 'Jours d’approvisionnement*',
                    'System configuration': 'Paramétrage du système',
                    'Technical info': 'Info technique',
                    Technician: 'Technicien',
                    'Technician filter': 'Filtre techniciens',
                    Temperature: 'Température relevée',
                    'Temperature curve': 'Courbe de température',
                    'Temperature lock': 'Blocage température',
                    'Temperature set': 'Température réglée',
                    'Temperature unit': 'Unité de température',
                    'The list cannot be empty':
                        'La liste ne peut pas être vide',
                    'The username for this machine is':
                        'Le nom d’utilisateur de la machine est',
                    'This Month': 'Ce mois',
                    'This week': 'Cette semaine',
                    Thursday: 'Jeudi',
                    'Time alarm red LEDs': 'Tempo alarme LEDs rouges',
                    'Time alarm temperature': 'Tempo alarme température',
                    'Time alarm yellow LEDs': 'Tempo alarme LEDs jaunes',
                    'Time door unlock': 'Tempo libération porte',
                    'Timer alarm door open': 'Tempo alarme porte ouverte',
                    To: 'au',
                    Today: 'Aujourd’hui',
                    'Total added products': 'Total produits ajoutés',
                    'Total number different products':
                        'Total produits différents',
                    'Total number products': 'Total produits',
                    'Total products sold': 'Total produits vendus',
                    'Total purchase price': 'Total prix d’achat',
                    'Total range': 'Fourchette total',
                    'Total removed products': 'Total produits retirés',
                    'Total result': 'CA total',
                    'Transaction serial': 'Numéro de transaction',
                    Tuesday: 'Mardi',
                    Type: 'Type',
                    'Upload logo': 'Uploader logo',
                    'Upload machine logo': 'Uploader logo distributeur',
                    'Upload picture': 'Importer une photo',
                    'Validate priority changes':
                        'Valider changements priorités',
                    Version: 'Version',
                    'Volume unit': 'Unité de volume',
                    'We sent an email to the administration team, they will get back to you shortly.':
                        'Nous avons envoyé un mail à l’équipe d’administration, ils reviendront vers vous bientôt.',
                    Wednesday: 'Mercredi',
                    'Week ': 'Sem. ',
                    'Weight unit': 'Unité de poids',
                    'Year and month': 'Choix mois/année',
                    Yes: 'Oui',
                    'You have unsaved changes, are you sure you want to leave?':
                        'Vous avez des modifications non enregistrées, êtes vous sûr de vouloir quitter la page?',
                    Zones: 'Zones',
                },
            },

            'es-ES': {
                translations: {
                    actions: 'Acciones',
                    activate: 'Activar',
                    activated: 'Activado',
                    active: 'Activo',
                    add: 'Añadir',
                    addProductOrder: 'Añadir productos al pedido',
                    address: 'Dirección',
                    admin: 'Admin',
                    ageLimit: 'No se admiten menores de 18 años',
                    alarmLowStock: 'Alarma de existencias bajas',
                    all: 'Todos',
                    allergens: 'Alérgenos',
                    alreadyLoggedInText:
                        '¡Ay! Ya ha iniciado sesión. Cierre todas las ventanas privadas del navegador e inténtelo de nuevo.',
                    alreadyLoggedInTitle: 'Ya conectado',
                    amount: 'Monto',
                    amountCart: 'Importe cesta',
                    amountCreditCard: 'Importe tarjeta de crédito',
                    amountKonvives: 'Importe Konvives',
                    amountTotal: 'Importe total',
                    amountVat: 'Monto IVA',
                    amountWithoutVat: 'Monto sin IVA',
                    amountWithVat: 'Monto con IVA',
                    anonymous: 'Anónimo',
                    approved: 'Aprobado',
                    askAgeConfirmation:
                        'Pedir confirmación de la edad (productos con límite de edad)',
                    atLeastOne: 'Debe ser al menos 1.',
                    author: 'Autor',
                    authorisationRequested: 'Autorización solicitada',
                    avatar: 'avatar',
                    back: 'Volver',
                    banknoteReader: 'Lector de billetes',
                    bbd: 'FDC',
                    bbdOutdated: 'FDC superado',
                    bbdSoonOutdated: 'FDC pronto superado',
                    bbdWithDate: 'FDC: {{date}}',
                    belgium: 'Bélgica',
                    block: 'Bloquear',
                    blockCard: 'Bloquear la tarjeta',
                    blockedCards: 'Tarjetas bloqueadas',
                    brand: 'Marca',
                    buildingFloor: 'Edificio / suelo',
                    cancelledFeminine: 'Cancelado',
                    cancellingOrder: 'Cancelación de pedido',
                    cancelOrder: 'Cancelar el pedido',
                    cancelReason: 'Motivo de cancelación',
                    carbs: 'Carbohidratos',
                    card: 'Tarjeta',
                    cardAlreadyBlocked: 'La tarjeta ya está bloqueada.',
                    cardNumber: 'Número de tarjeta',
                    cardNumberAlreadyInUse:
                        'El número de tarjeta ya está en uso.',
                    cardType: 'Tipo de tarjeta',
                    cartDiscount: 'Descuento cesta',
                    cash: 'Efectivo',
                    catalogue: 'Catalogue',
                    categories: 'Categorías',
                    category: 'Categoría',
                    channelNotConnected: 'Canal no conectado',
                    chooseMachineType: 'Elija el tipo de máquina',
                    chooseManager: 'Elija un gestor',
                    chooseSelection: 'Elija una opción',
                    city: 'Ciudad',
                    clickOnMicrowave:
                        'Haga clic en un microonda para activarlo / desactivarlo.',
                    client: 'Cliente',
                    clientCreation: 'Creación cliente',
                    clientFilter: 'Filtro cliente',
                    clients: 'Clientes',
                    closedLocker: 'Casillero cerrado',
                    closingTime: 'Horario de cierre',
                    codes: 'Códigos',
                    coinAcceptor: 'Compacto',
                    column: 'Columna ',
                    commercialInformation: 'Información comercial',
                    communicationLost: 'Comunicación perdida',
                    confirm: 'Confirmar',
                    confirmDeletionText:
                        '¿Seguro que quieres borrarlo definitivamente?',
                    confirmDeletionTitle: 'Confirmación de la supresión',
                    connectionToTerminal: 'Conexión al terminal',
                    contact: 'Contactar',
                    contacted: 'Contactado',
                    contactNumber: 'Número de contacto',
                    containsIcoupon: 'Contiene iCoupon',
                    contract: 'Contrato',
                    contractDuration: 'Duración del contrato (meses)',
                    contractNumber: 'Número de contrato',
                    cookingRequirements: 'Requisitos de cocción',
                    cookingTemperature: 'Temperatura de cocción',
                    cookingTime: 'Tiempo de cocción',
                    copied: 'Copiado al portapapeles.',
                    correct: 'Correcto',
                    country: 'País',
                    created: '¡Creado con éxito!',
                    creation: 'Creación',
                    creationDate: 'Fecha de creación',
                    creditCard: 'Tarjeta de crédito',
                    customerService: 'Servicio al cliente',
                    customerServiceMessage:
                        '¿Tiene algún problema? Cree un ticket en <link />. Podrás seguir su progreso.',
                    customisedFeminine: 'Personalizada',
                    date: 'Fecha',
                    dateEnd: 'Fecha final',
                    datePassage: 'Fecha de la visita',
                    datePassageInfo: 'Fecha de la visita: {{date}}',
                    dates: 'Fechas',
                    dateSignature: 'Fecha de firma',
                    dateStart: 'Fecha de inicio',
                    dayEnd: 'Dia final',
                    dayEndError:
                        'La fecha de finalización es anterior a la fecha de inicio.',
                    dayStart: 'Dia de inicio',
                    dayStartError:
                        'La fecha de inicio supera  la fecha de finalización.',
                    deactivate: 'Desactivar',
                    deactivated: 'Desactivado',
                    defaultLanguageCustomer: 'Idioma cliente por defecto',
                    defaultLanguageIntervenor:
                        'Idioma interviniente por defecto',
                    delete: 'Borrar',
                    deleted: '¡Eliminado con éxito!',
                    deliveries: 'Entregas',
                    deliveryMan: 'Repartidor',
                    deliveryManCreation: 'Creación repartidor',
                    deliveryMen: 'Repartidores',
                    description: 'Descripción',
                    desired: 'Deseado',
                    destocking: 'Desalmacenaje',
                    diagnostic: 'Diagnóstico',
                    discount: 'Descuento',
                    discounts: 'Promociones',
                    discountsPriorities: 'Prioridades de promociones',
                    dispensingCancelled: 'Dispensación cancelada',
                    dispute: 'Impugnación',
                    disputedFeminine: 'Contestada',
                    disputeState: 'Estado del litigio',
                    distributionSpeed: 'Velocidad de distribución',
                    distributor: 'Distribuidor',
                    divider: 'Separador',
                    domainName: 'Nombre de dominio',
                    doorOpen: 'Puerta abierta',
                    download: 'Descargar',
                    dropFileHere: 'Cargue el archivo aquí.',
                    duplicate: 'Duplicar',
                    elevatorFault: 'Fallo del ascensor',
                    eligibleFridgeWeight: 'Peso admisible frigorífico',
                    eligibleLuncheonVouchers: 'Derecho cheques restaurante',
                    email: 'Correo electrónico',
                    emailAlreadyInUse:
                        'Este correo electrónico ya está en uso.',
                    emailError: 'Se requiere un correo electrónico válido.',
                    emailResetPassword:
                        '¡Se ha enviado un correo electrónico para restablecer la contraseña!',
                    emailSignatory: 'Correo electrónico firmante',
                    employerContribution: 'Contribución empleador',
                    empty: 'Vacío',
                    encodedProducts: 'Productos codificados',
                    endTime: 'Hora final',
                    energy: 'Energía',
                    english: 'Inglés',
                    errorAlarmRedLed:
                        'El temporizador rojo debe ser superior al temporizador de LED amarillo ajustado.',
                    errorAlarmYellowLedOne:
                        'El temporizador de la alarma amarilla debe ajustarse como mínimo a 5 segundos después de abrir la puerta.',
                    errorAlarmYellowLedTwo:
                        'El temporizador de la alarma amarilla debe ajustarse al menos 5 segundos antes que el temporizador del LED rojo.',
                    errorDiffTempTooHighOne:
                        'El diferencial debe ser inferior al umbral de alta temperatura menos la temperatura de consigna.',
                    errorDiffTempTooHighTwo:
                        'El diferencial debe ser inferior a la temperatura de consigna restada por el umbral de baja temperatura.',
                    errorFieldRequired: 'Este campo es obligatorio.',
                    errorHighTempThresh:
                        'El umbral de temperatura alta debe ser superior al umbral de temperatura baja y no debe superar los 25 grados.',
                    errorImportNumeric: 'Este campo debe ser un número.',
                    errorImportString: 'Este campo no puede ser un número.',
                    errorInUse: 'Este objeto está actualmente en uso.',
                    errorLowTempThreshTooHigh:
                        'El umbral de baja temperatura debe ser inferior a la temperatura de consigna sumada por la diferencial.',
                    errorLowTempThreshTooLow:
                        'El umbral de baja temperatura debe ser inferior a la temperatura de consigna más el diferencial.',
                    errorOpenDoorTimer:
                        'El temporizador de desbloqueo de la puerta debe estar al menos 5 segundos por debajo del temporizador de alarma amarilla ajustado.',
                    errorPhoto: 'Foto requerida.',
                    errorSetpointTempTooHigh:
                        'La temperatura debe estar por debajo del umbral de alta temperatura restado del diferencial.',
                    errorSetpointTempTooLow:
                        'La temperatura debe ser superior al umbral de baja temperatura más el diferencial.',
                    errorTempNotBetweenSetLimits:
                        'La temperatura debe ajustarse entre -30 y 23 °C inclusive.',
                    errorTryLater:
                        'Se ha producido un error, inténtelo de nuevo más tarde.',
                    errorUserCreation:
                        'Se ha producido un error al crear el usuario Konsole.',
                    excelPercentage: '#,#0.0" %"',
                    excelPrice: '#,##0.00" €"',
                    excelPriceWeight: '#,##0.00" € / Kg"',
                    expiredFeminine: 'Expirado',
                    export: 'Exportar',
                    exportInPreparation: 'La exportación está en preparación…',
                    fats: 'Grasas',
                    fibres: 'Fibras',
                    fieldRequiredFill: 'Rellene todos los campos obligatorios.',
                    fileSizeError: 'Tamaño del archivo es demasiado grande.',
                    fill: 'Lleno',
                    filters: 'Filtros',
                    final: 'Final',
                    firstName: 'Apellidos',
                    firstNameSignatory: 'Apellidos firmante',
                    forgottenPassword: '¿Olvidó su contraseña?',
                    france: 'Francia',
                    french: 'Francés',
                    friday: 'Viernes',
                    fridgeRfid: 'e-Frigorífico',
                    fridgeWeight: 'Peso frigorífico',
                    from: 'Del',
                    furtherInformation: 'Información adicional',
                    general: 'General',
                    generalInformation: 'Informaciones generales',
                    generate: 'Generar',
                    germany: 'Alemania',
                    globalInformation: 'Información global',
                    groupBy: 'Grupo por',
                    grouped: 'Grupo',
                    history: 'Historial',
                    idCardReader: 'Lector de documento de identidad',
                    identifier: 'Identificador',
                    impersonate: 'Suplantación de la identidad',
                    impersonateInstructions:
                        'Haga clic con el botón derecho en <link /> y ábralo en una nueva ventana privada del navegador. ¡Ya está, has suplantado la identidad!',
                    import: 'Importación',
                    imported: '¡Importado con éxito!',
                    importModificationText:
                        '¿Estás seguro de que quieres cambiar el tipo de importación? Cualquier cambio se perderá.',
                    importModificationTitle: 'Modificación de la importación',
                    importProducts: 'Importación de productos',
                    importProductsLimited:
                        'Importación de productos limitada al {{number}}',
                    importVerb: 'Importar',
                    inactive: 'Inactivo',
                    incidents: 'Incidentes',
                    incidentsRabbitmq: 'Incidentes RabbitMQ',
                    inFitsAndStarts: 'A trompicones',
                    infoOutdated:
                        'Las FDC vencidas no se tienen en cuenta en la fecha de visita seleccionada.',
                    informative: 'Informativo',
                    inPreparation: 'En preparación',
                    inProgress: 'En curso…',
                    instructions: 'Instrucciones',
                    internet: 'Internet',
                    interventions: 'Intervenciones',
                    ipAddress: 'Dirección IP',
                    italy: 'Italia',
                    konvivesLink: 'Enlace Konvives',
                    lastActivityDate: 'Última fecha de actividad',
                    lastLoss: 'Última pérdida:',
                    lastName: 'Nombre',
                    lastNameSignatory: 'Nombre firmante',
                    lastSign: 'Última señal:',
                    lifespan: 'Vida útil (días)',
                    line: 'Línea',
                    loading: 'Carga en curso…',
                    locationErrorDuplicate:
                        'Un número de selección está duplicado.',
                    locationErrorEmpty: 'Una selección está vacía.',
                    locationErrorMotor:
                        'Dos motores tienen las mismas posiciones.',
                    locationErrorPlanogramName:
                        'Nombre del planograma faltante.',
                    locationErrorPlanogramOrder:
                        'Falta el orden del planograma.',
                    lockerCold: 'Casillero refrigerado',
                    lockerDry: 'Casillero seco',
                    logIn: 'Conectar',
                    login: 'Conexión',
                    logOut: 'Desconectar',
                    luxembourg: 'Luxemburgo',
                    machine: 'Máquina',
                    machineChoice: 'Elección de la máquina',
                    machineChoiceDetails:
                        'Elija la máquina en la que desea crear el planograma.',
                    machineOptionsAndTechnicalData:
                        'Datos técnicos / opciones de máquinas',
                    machines: 'Máquinas',
                    machineType: 'Tipo de máquina',
                    managementSelection: 'Gestión de selecciones',
                    managementTray: 'Gestión de bandejas',
                    manager: 'Director',
                    managerCreation: 'Creación director',
                    managerEditionText:
                        '¿Estás seguro de que quieres cambiar de director? Cualquier cambio se perderá.',
                    managerEditionTitle: 'Edición director',
                    managerItemCode: 'Código artículo director',
                    managers: 'Directores',
                    manual: 'Manual',
                    marketingImagesAndVideos: 'Imágenes / vídeos de marketing',
                    maximum: 'Máximo',
                    mealVoucher: 'Vale de comida',
                    menuNotTaken: 'Menú no tenido en cuenta',
                    menus: 'Menús',
                    microwave: 'Microonda',
                    microwaveCreation: 'Creación microonda',
                    microwaves: 'Microondas',
                    mifareCode: 'Código MIFARE',
                    mifareCodeAlreadyInUse: 'El código MIFARE ya está en uso.',
                    model: 'Modelo',
                    modification: 'Modificación',
                    modificationDate: 'Fecha de modificación',
                    modifyProductInfo: 'Editar la información del producto',
                    modifyTechnicalData: 'Modificar los datos técnicos',
                    monday: 'Lunes',
                    month: 'Mes',
                    motor: 'Motor',
                    motorActivation:
                        'Activación del motor tras la distribución',
                    motorFailure: 'Fallo del motor',
                    name: 'Nombre',
                    navigationBar: 'Barra de navegación',
                    netherlands: 'Países Bajos',
                    newClient: 'Neuvo cliente',
                    newDeliveryMan: 'Nuevo repartidor',
                    newManager: 'Nuevo director',
                    newMicrowave: 'Nuevo microonda',
                    newNamePriceTable: 'Nuevo nombre para la tabla de precios',
                    newOrder: 'Nuevo pedido',
                    newProduct: 'Nuevo producto',
                    newProfile: 'Nuevo perfil',
                    newReport: 'Nuevo informe',
                    newService: 'Nuevo servicio',
                    newSite: 'Nuevo sitio',
                    newSupplier: 'Nuevo proveedor',
                    newTable: 'Nueva tabla',
                    newTechnician: 'Nuevo técnico',
                    next: 'Siguiente',
                    no: 'No',
                    noAdmin: 'No admin',
                    noBlockedCardAvailable:
                        'No se han encontrado tarjetas bloqueadas.',
                    noChange: 'Ningún cambio.',
                    noClientAvailable: 'No hay cliente disponible.',
                    noDeliveryManAvailable: 'No hay repartidor disponible.',
                    noDiagnosticAvailable: 'No hay diagnóstico disponible.',
                    noEmployerContributionAvailable:
                        'No hay contribución empleador disponible.',
                    noManagerAvailable: 'No hay director disponible.',
                    noMicrowaveAvailable: 'No hay microonda disponible.',
                    none: 'Ninguno',
                    noOrderAvailable: 'No hay pedido disponible.',
                    noPlanogramAvailable: 'No hay planograma disponible.',
                    noProductAvailable: 'No hay producto disponible.',
                    noProductSelected: 'No hay productos seleccionados.',
                    noProfileAvailable: 'No hay perfil disponible.',
                    noRefillAvailable: 'No hay recarga disponible.',
                    noReportAvailable: 'No hay informe disponible.',
                    noResultAvailable: 'No hay resultado disponible.',
                    noSaleAvailable: 'No hay venta disponible.',
                    noServiceAvailable: 'No hay servicio disponible.',
                    noSiteAvailable: 'No hay sitio disponible.',
                    noSupplierAvailable: 'No hay proveedor disponible.',
                    noTechnicianAvailable: 'No hay técnico disponible.',
                    noUserAvailable: 'No hay usuario disponible.',
                    numberProducts: 'Número de productos incorrectos',
                    nutritionalValues: 'Valores nutricionales',
                    onDelivery: 'En entrega',
                    onlyShortBbd: 'Sólo FDC corto',
                    openingTime: 'Horario de apertura',
                    openingTimes: 'Horarios de apertura',
                    openLocker: 'Abrir la taquilla',
                    openLockerConfirmation:
                        '¿Estás seguro de que quieres abrir la taquilla {{mapping}}?',
                    operations: 'Operaciones',
                    order: 'Pedido',
                    orderCreation: 'Creación pedido',
                    orderNotFound: 'Pedido no encontrado',
                    orderNumber: 'Pedido n°{{number}}',
                    orders: 'Pedidos',
                    other: 'Otro',
                    park: 'Parque',
                    password: 'Contraseña',
                    passwordConfirm: 'Confirmar contraseña',
                    passwordNew: 'Nueva contraseña',
                    passwordResetAction: 'Restablecer contraseña',
                    passwordResetTitle: 'Restablecer contraseña',
                    passwordRuleCommon:
                        'Las contraseñas demasiado comunes/obvias también están bloqueadas.',
                    passwordRuleIntro: 'La contraseña debe contener al menos:',
                    passwordRuleLength: '12 caracteres minimum',
                    passwordRuleLowercase: '2 letras minúsculas',
                    passwordRuleNumber: '2 números',
                    passwordRuleSpecial: '2 caracteres especiales',
                    passwordRuleUppercase: '2 letras mayúsculas',
                    passwordsDoNotMatch: 'Las contraseñas no coinciden.',
                    passwordsMustBeStronger:
                        'La contraseña debe ser más segura.',
                    paymentMethod: 'Método de pago',
                    pending: 'En espera',
                    phone: 'Teléfono',
                    phoneSignatory: 'Teléfono firmante',
                    photo: 'Foto',
                    planogramCreate: 'Crear un planograma',
                    planogramDeleteAsk:
                        '¿Estás seguro de que quieres borrar este planograma?',
                    planogramOrder: 'Orden',
                    planograms: 'Planogramas',
                    port: 'Puerto',
                    portugal: 'Portugal',
                    position: 'Posición',
                    postalCode: 'Código postal',
                    power: 'Corriente',
                    preferLibreOffice:
                        'Para un uso óptimo, prefiere LibreOffice.',
                    price: 'Precios',
                    priceKonvives: 'Precio Konvives',
                    pricePrivateCard: 'Precio tarjeta privada',
                    priceStandard: 'Precio estándar',
                    priceTableCreation: 'Creación tabla de precios',
                    priceTables: 'Tablas de precios',
                    priceUnit: 'Precio unitario',
                    priceWeight: 'Precio por peso',
                    printer: 'Impresora',
                    privateCard: 'Tarjeta privada',
                    problem: 'Problema',
                    product: 'Producto',
                    productChange: 'Cambio de producto',
                    productCreation: 'Creación producto',
                    productExpired: 'Producto caducado',
                    productListErrors: 'Lista de errores del producto',
                    products: 'Productos',
                    productsDistributed: 'Productos dispensados',
                    productsExcluded: 'Productos a excluir',
                    productsNotDistributed: 'Productos no dispensados',
                    productSoldOut: 'Producto agotado',
                    profile: 'Perfil',
                    profileCreation: 'Creación perfil',
                    profiles: 'Perfiles',
                    proteins: 'Proteínas',
                    pspReference: 'Referencia PSP',
                    purchaseInvoice: 'Factura de compra',
                    purchasePrice: 'Precio de compra',
                    purchasePriceAsc: 'Precio de compra (ascendente)',
                    purchasePriceDesc: 'Precio de compra (descendente)',
                    quantity: 'Cantidad',
                    quantityAsc: 'Cantidad (ascendente)',
                    quantityDesc: 'Cantidad (descendent)',
                    queueFull: 'Cola llena',
                    reading: 'Lectura',
                    readyFeminine: 'Listo',
                    reason: 'Razón',
                    rebootApt: 'Reiniciar el TPA',
                    rebootAptConfirmation:
                        '¿Seguro que quieres reiniciar el TPA?',
                    receipt: 'Recibo',
                    recommended: 'Recomendado',
                    recommendedDeliveryTime: 'Hora de entrega recomendado',
                    recreditation: 'Recreditación',
                    refill: 'Recarga',
                    refills: 'Recargas',
                    refund: 'Reembolso',
                    refundedFeminine: 'Reembolsada',
                    refunds: 'Reembolsos',
                    refundVerb: 'Reembolsar',
                    refuse: 'Denegar',
                    refused: 'Denegado',
                    refusedFeminine: 'Denegada',
                    removedFeminine: 'Retirada',
                    rename: 'Renombrar',
                    reportQueue: '¡Informe en la cola!',
                    reports: 'Informes',
                    reportsGeneratedKept:
                        'Los informes generados se conservan durante 30 días antes de ser eliminados.',
                    resetPassword: 'Restablecer contraseña',
                    resetPasswordInstruction:
                        'Introduzca su dirección de correo electrónico. Recibirá un enlace para restablecer su contraseña.',
                    resetSelectionPriceWeight:
                        'Restablecimiento de las selecciones de productos',
                    resetSelectionPriceWeightTextPlural:
                        'Las selecciones de los productos cambiados al precio por peso presentes en las máquinas serán vaciadas.',
                    resetSelectionPriceWeightTextSingular:
                        'Las selecciones del producto presentes en las máquinas serán vaciadas.',
                    restartComputer: 'Reiniciar el ordenador',
                    restartComputerConfirmation:
                        '¿Seguro que quieres reiniciar el ordenador?',
                    retrievedBySomeoneElse: 'Recogido (otro)',
                    retrievedFeminine: 'Recogido',
                    sale: 'Venta',
                    saleReport: 'Informe de venta',
                    saleReportCreation: 'Creación informe de venta',
                    saleReports: 'Informes de venta',
                    sales: 'Ventas',
                    salesLog: 'Registro de ventas',
                    salesLogCreation: 'Creación registro de ventas',
                    saleStatus: 'Statut vente',
                    salt: 'Sal',
                    saturatedFat: 'Ácidos grasos saturados',
                    saturday: 'Sábado',
                    screen: 'Pantalla',
                    searchAddress: 'Buscar dirección',
                    sector: 'Sector',
                    selectCancelOrderReason:
                        'Por favor, seleccione una razón de cancelación.',
                    selectClientSiteOrTerminal:
                        'Seleccione un cliente, un centro o un terminal.',
                    selection: 'Selección',
                    selectionNotConfigured: 'Selección no configurada',
                    selectionNumber: 'Número de selección',
                    selectKonviveOrPhone: `Seleccionar un Konvive o agregar el número de teléfono`,
                    selectLockerToOpen:
                        'Selecciona la casilla que quieres abrir',
                    selectSiteDelivery: 'Seleccionar un sitio de entrega',
                    selectSiteOrTerminal: 'Seleccione un sitio o un terminal.',
                    selfService: 'Autoservicio',
                    sent: '¡Enviado con éxito!',
                    serialNumber: 'Número de serie',
                    service: 'Servicio',
                    serviceCreation: 'Creación servicios',
                    serviceFilter: 'Filtro servicio',
                    serviceReport: 'Informe de servicio',
                    serviceReportCreation: 'Creación informe de servicio',
                    serviceReports: 'Informes de servicio',
                    services: 'Servicios',
                    settings: 'Parámetros',
                    signatory: 'Firmante',
                    signature: 'Firma',
                    site: 'Sitio',
                    siteCreation: 'Creación sitio',
                    siteFilter: 'Filtro sitio',
                    sites: 'Sitios',
                    size: 'Talla',
                    sizeInform: 'Cambie el tamaño de las selecciones.',
                    sortBy: 'Ordenar por',
                    spain: 'España',
                    spanish: 'Español',
                    split: 'Separar',
                    standard: 'Estándar',
                    startTime: 'Hora de inicio',
                    status: 'Estado',
                    steps: 'Pasos',
                    stock: 'Existencias',
                    stockMachines: 'Stock de máquinas',
                    stockMaximum: 'Existencias máximas',
                    stockRecommended: 'Existencias recomendadas',
                    stockReport: 'Informe de existencias',
                    subcategory: 'Subcategoría',
                    sugar: 'Azúcar',
                    sunday: 'Domingo',
                    supervisor: 'Responsable',
                    supplier: 'Proveedor',
                    supplierCreation: 'Creación proveedor',
                    supplierFilter: 'Filtro proveedor',
                    suppliers: 'Proveedors',
                    supply: 'Suministro',
                    supplyDays: 'Días de suministro',
                    supplyReport: 'Informe de suministro',
                    support: 'Asistencia',
                    supportEmail: 'Correo electrónico de asistencia',
                    supportPhone: 'Teléfono de asistencia',
                    switchInactive: 'Pasar a inactivo',
                    switchPending: 'Pasar a la espera',
                    switzerland: 'Suiza',
                    table: 'Tabla',
                    technician: 'Técnico',
                    technicianCreation: 'Creación técnicos',
                    technicians: 'Técnicos',
                    terminal: 'Terminal',
                    terminalFilter: 'Filtro terminal',
                    terminals: 'Terminales',
                    text: 'Texto',
                    theme: 'Tema',
                    thisLink: 'este enlace',
                    thursday: 'Jueves',
                    ticket: 'Ticket',
                    timeEndError:
                        'La hora de finalización es anterior a la hora de inicio.',
                    timeSlotNumber: 'Franja {{number}}',
                    timeSlotOverlap:
                        'El horario no debe solaparse con otro horario.',
                    timeSlots: 'Franjas horarias',
                    timeStartError:
                        'La hora de inicio supera la hora de finalización.',
                    to: 'al',
                    toRefill: 'A recargar',
                    total: 'Total',
                    totalRefund: 'Reembolso total :',
                    transactions: 'Transacciones',
                    tuesday: 'Martes',
                    turnoverWithoutVat: 'Facturación (sin IVA)',
                    turnoverWithoutVatAsc: 'Facturación (sin IVA) (creciente)',
                    turnoverWithoutVatDesc:
                        'Facturación (sin IVA) (decreciente)',
                    turnoverWithVat: 'Facturación (con IVA)',
                    type: 'Tipo',
                    unblockCard: 'Desbloquear la tarjeta',
                    unitedKingdom: 'Reino-Unido',
                    unitedStateOfAmerica: 'Estados Unidos de América',
                    units: 'Unidades',
                    unknownError: 'Error desconocido',
                    unlockHatch: 'Desbloquear la trampilla',
                    unlockHatchConfirmation:
                        '¿Estás seguro de que quieres abrir la trampilla?',
                    update: 'Actualizando',
                    updated: '¡Actualizado con éxito!',
                    updatedLightningSchedules:
                        'Horario de iluminación actualizado.',
                    ups: 'Inversor',
                    userInformation: 'Información usuario',
                    userKonsole: 'Usuario Konsole',
                    username: 'Nombre de usuario',
                    usernameAlreadyInUse:
                        'Este nombre de usuario ya está en uso.',
                    usernameOrPasswordIncorrect:
                        'Nombre de usuario o contraseña incorrecto.',
                    users: 'Usuarios',
                    usersKonsole: 'Usuarios Konsole',
                    usersKonsoleCreation: 'Creación usuario Konsole',
                    usersNew: 'Nuevo usuario',
                    vat: 'IVA',
                    volume: 'Volumen',
                    wednesday: 'Miércoles',
                    weight: 'Peso',
                    wrongPrice: 'Precio incorrecto',
                    wrongProduct: 'Producto equivocado',
                    yes: 'Sí',
                    zone: 'Zona',

                    // Old
                    '12 last days': '12 últimos días',
                    '12 last months': '12 últimos meses',
                    '12 last weeks': '12 últimas semanas',
                    'Accessible machines': 'Máquinas accesibles',
                    'Add new consumer': 'Agregar nuevo consumidor',
                    'Add new machine': 'Agregar nueva máquina',
                    All: 'Todos',
                    'Are you sure you want to delete this machine?':
                        '¿Está seguro de que desea eliminar esta máquina?',
                    Average: 'Promedio',
                    'Best before date': 'Fecha de caducidad',
                    'Best before date filter': 'Filtro de fecha de caducidad',
                    'Best vending machines': 'Las 5 mejores máquinas en ventas',
                    'Best vending products':
                        'Los 5 mejores productos en ventas',
                    'Build date': 'La fecha de construcción',
                    'Category list': 'Lista de categorías',
                    Client: 'Cliente',
                    Clients: 'Clientes',
                    'Cold chain': 'Cadena de frío',
                    'compared to last month': 'comparado con el mes pasado',
                    'Connected machines': 'Máquinas conectadas',
                    'Connexion type': 'Tipo de conección',
                    'Creation date': 'Fecha de creación',
                    Credit: 'Crédito',
                    'Delivery man': 'Repartidor',
                    Description: 'Descripción',
                    Details: 'Detalles',
                    'Discount amount': 'Importe de descuento',
                    'Distributor volume': 'Volumen del distribuidor',
                    'E-mail': 'Correo electrónico',
                    'E-mail address': 'Dirección de correo electrónico',
                    'Enabled?': '¿Activado?',
                    'End date': 'Fecha final',
                    'Fidelity points': 'Points de fidélité',
                    'First name': 'Nombre',
                    Friday: 'Viernes',
                    'Global info': 'Información global',
                    'Import new profile picture':
                        'Importar nueva foto de perfil',
                    'Installation date': 'Fecha de instalación',
                    'Last name': 'Apellido',
                    'Machine name': 'Nombre de la máquina',
                    'Machines filter': 'Filtrar por máquina',
                    'Machines form': 'Formulario de Máquinas',
                    'Max products': 'Cantidad máxima de productos',
                    'Maximum number of products':
                        'Cantidad máxima de productos',
                    Mode: 'Modo',
                    Monday: 'lunes',
                    'Monthly results all machines':
                        'Resultados mensuales de todas las máquinas',
                    'Nb products sold all machines':
                        'Número de productos vendidos en todas las máquinas',
                    'Nb transactions all machines':
                        'Número de transacciones en todas las máquinas',
                    'Nb. of sales': 'Numero de ventas',
                    'Nb. of transactions': 'Núm de transacciones',
                    No: 'No',
                    'Number of products': 'Número de productos',
                    'Number of products sold': 'Numero de productos vendidos',
                    'Number of transactions': 'Numero de transacciones',
                    'Operator list': 'Lista de clientes',
                    'Operator name': 'Nombre del cliente',
                    'Origin of creation': 'Origen de la creación',
                    'out of': 'fuera de',
                    'Paiement method': 'Método de pago',
                    'Phone number': 'Número de teléfono',
                    'Price table': 'Lista de precios',
                    'Private ID': 'ID privado',
                    Product: 'Producto',
                    Products: 'Productos',
                    'Products sold': 'Productos vendidos',
                    Profile: 'Mi perfil',
                    Provider: 'Proveedor',
                    Quantity: 'Cantidad',
                    Results: 'Resultados',
                    Revenues: 'Ingresos',
                    Saturday: 'Sábado',
                    'Search machine name': 'Buscar por nombre de maquina',
                    'Search products name': 'Buscar por producto',
                    'Search transaction number': 'Buscar número de transacción',
                    Send: 'Enviar',
                    'Site name': 'Nombre del sitio',
                    'Sites filter': 'Filtrar por sitio',
                    'Software version': 'Versión del software',
                    'Start date': 'Fecha de iniciot',
                    'Stock in percentage': 'Stock en porcentaje',
                    Sunday: 'Domingo',
                    Supply: 'Suministro',
                    'Supply days *': 'Días de suministro*',
                    'System configuration': 'Configuración del sistema',
                    'Temperature curve': 'Curva de temperatura',
                    'This Month': 'Este mes',
                    'This week': 'Esta semana',
                    Thursday: 'Jueves',
                    Today: 'Hoy',
                    'Total products sold': 'Total de productos vendidos',
                    'Total range': 'Rango total',
                    'Transaction serial': 'Número de transacción',
                    Tuesday: 'Martes',
                    'Upload picture': 'Subir foto',
                    Wednesday: 'Miércoles',
                    'Week ': 'Semana',
                    Yes: 'Si',
                },
            },
        },
    })

// eslint-disable-next-line unicorn/prefer-export-from
export default i18next
